import { AppManifestV0, parse as parseV0 } from './app-manifest-v0';
import { AppManifestV1, parse as parseV1 } from './app-manifest-v1';
import { AppManifestV2, parse as parseV2 } from './app-manifest-v2';
import detectManifestVersion from './detect-manifest-version';
import { v0ToV1 } from './parse';

type VersionNumber = 'V1' | 'V2';
type AppManifest = AppManifestV1 | AppManifestV2;

interface ParsedManifest {
  versionNumber: VersionNumber;
  data: AppManifest;
}

const parseManifest = (unknownData: unknown): ParsedManifest | null => {
  const detected = detectManifestVersion(unknownData);

  if (detected === 'V0') {
    const v0 = parseV0(unknownData as AppManifestV0);
    const v1 = v0ToV1(v0);
    return {
      versionNumber: 'V1',
      data: v1,
    };
  }

  if (detected === 'V1') {
    const v1 = parseV1(unknownData as AppManifestV1);
    return {
      versionNumber: 'V1',
      data: v1,
    };
  }

  if (detected === 'V2') {
    const v2 = parseV2(unknownData as AppManifestV1);
    return {
      versionNumber: 'V2',
      data: v2,
    };
  }

  return null;
};

export { ParsedManifest, VersionNumber, AppManifest };
export default parseManifest;
